import React from 'react'
import logo from '@/shared/assets/logo.webp'
import {useLocation, useNavigate} from 'react-router-dom'

import cls from './footer.module.scss'
import {scrollIntoView} from '@/shared/lib/utils/scrollIntoView'
import { useTranslation } from 'react-i18next'

export const Footer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const {t} = useTranslation()
    return (
        <div className={cls.footerWrapper}>
            <footer className={cls.Footer}>
                <div className={cls.topblock}>
                    <img
                        onClick={() => {
                            window.location.href="https://stellar-bets.com/"
                        }}
                        alt="some problems"
                        src={logo}
                        className={cls.logo}
                    />

                    <nav>
                        <a
                            href="https://stellar-bets.com/"
                        >
                            {t('navigation.aboutus')}
                        </a>
                        <p onClick={() => scrollIntoView('benefits')}>{t('navigation.benefits')}</p>
                        <p onClick={() => scrollIntoView('instructions')}>{t('navigation.howwework')}</p>
                    </nav>
                </div>
                <div className={cls.copyright}>
                    <p>© 2024 Stellar Bets</p>
                    <p>{t('rights')}</p>
                </div>
            </footer>
        </div>
    )
}
